import { supabase } from './supabase';

/**
 * Lists contact form submissions after admin gate RPC check.
 */
export async function fetchContactMessagesForAdmin(adminEmail, adminPassword) {
  const { data, error } = await supabase.rpc('admin_list_contact_messages', {
    p_admin_email: adminEmail,
    p_admin_password: adminPassword,
  });

  if (error) {
    throw new Error(error.message || 'Request failed');
  }

  if (!data || data.success !== true) {
    throw new Error(data?.error || 'Could not load contact messages');
  }

  const raw = data.messages;
  if (Array.isArray(raw)) return raw;
  return [];
}
